import { FunctionComponent, useEffect, useState } from 'react';
import {
    createEmptyCreateFacility,
    CreateFacility,
    Facility,
} from '@/models/facility';
import { Box, Button, Stack } from '@mui/material';
import { CreateFacilityCard } from '@/pageContents/liftOperatorsContent/formBlocks/facility/CreateFacilityCard';

type FacilitiesContainerProps = {
    value: (Facility | CreateFacility)[];
    name: string;
    onChange: (nextValue: (Facility | CreateFacility)[], name) => void;
};

export const FacilitiesContainer: FunctionComponent<
    FacilitiesContainerProps
> = ({ value, onChange, name }) => {
    const [internalFacilities, setInternalFacilities] = useState<
        (Facility | CreateFacility)[]
    >(value || []);

    const onDelete = (indexToDelete: number) => {
        const copyFacilities = [...internalFacilities];

        copyFacilities.splice(indexToDelete, 1);

        setInternalFacilities(copyFacilities);
    };

    const onAdd = () => {
        setInternalFacilities([
            ...internalFacilities,
            createEmptyCreateFacility(),
        ]);
    };

    useEffect(() => {
        onChange(internalFacilities, name);
    }, [internalFacilities]);

    return (
        <Box>
            <Stack spacing={3}>
                {internalFacilities?.map((facility, index) => (
                    <CreateFacilityCard
                        key={index}
                        createFacility={facility}
                        onChange={(value) => {
                            const copyFacilities = [...internalFacilities];

                            copyFacilities[index] = value;

                            setInternalFacilities(copyFacilities);
                        }}
                        onXClick={() => {
                            onDelete(index);
                        }}
                    />
                ))}
            </Stack>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    mt: 3,
                    p: 2,
                }}
            >
                <Button onClick={onAdd} variant='outlined'>
                    Neue Facility hinzufügen
                </Button>
            </Box>
        </Box>
    );
};
